export default "__VITE_ASSET__CmvPP_Ln__"